<template>
  <div style="height: 100%; width: 100%">
    <div class="img">
      <!-- <img src="../assets/images/login_img.png" alt="" /> -->
      <div class="opacity_wrapper"></div>
      <div class="form_container">
        <div class="section1">
          <div class="section_header_wrap">
            <div @click="goBack" class="back_btn_box">
              <img src="../assets/images/procedure//icon_arrow-left_white.svg" />
              <div>뒤로</div>
            </div>
            <img src="../assets/images/joyworks_logo.png" style="cursor: pointer" @click="goHome" alt="" />
          </div>
          <div class="title_text">
            <div>조이웍스</div>
            <div>A/S온라인 신청서</div>
          </div>
        </div>
        <div class="section2">
          <div class="section2_text">조이웍스 스토어 공식 판매처에서 구매한 제품은 당사의 AS 정책에 따른 서비스를 제공받을 수 있습니다.</div>
          <div class="section2_text">아래 신청서를 작성하시고 AS 받을 제품을 아래 주소로 보내주시기 바랍니다.</div>
        </div>
        <div class="section3">
          <div class="section_line">
            <div class="section_line_text">AS 진행 절차 안내</div>
            <div class="section_line_line"></div>
          </div>
          <div class="section3_icon_wrap">
            <div class="section3_radious">
              <div class="radious_number">01</div>
              <div class="section3_radious_wrap">
                <img src="../assets/images/procedure/write.png" alt="" />
              </div>
              <div class="section3_radious_text">신청서 작성 및 제출</div>
            </div>
            <div>
              <img src="../assets/images/procedure/icon_arrow-right.png" alt="" />
            </div>
            <div class="section3_radious">
              <div class="radious_number">02</div>
              <div class="section3_radious_wrap">
                <img src="../assets/images/procedure/send.png" alt="" />
              </div>
              <div class="section3_radious_text">제품 발송</div>
            </div>
            <div>
              <img src="../assets/images/procedure/icon_arrow-right.png" alt="" />
            </div>
            <div class="section3_radious">
              <div class="radious_number">03</div>
              <div class="section3_radious_wrap">
                <img src="../assets/images/procedure/regist.png" alt="" />
              </div>
              <div class="section3_radious_text">A/S 접수</div>
            </div>
            <div>
              <img src="../assets/images/procedure/icon_arrow-right.png" alt="" />
            </div>
            <div class="section3_radious">
              <div class="radious_number">04</div>
              <div class="section3_radious_wrap">
                <img src="../assets/images/procedure/going.png" alt="" />
              </div>
              <div class="section3_radious_text">A/S 진행</div>
            </div>
            <div>
              <img src="../assets/images/procedure/icon_arrow-right.png" alt="" />
            </div>
            <div class="section3_radious">
              <div class="radious_number">05</div>
              <div class="section3_radious_wrap">
                <img src="../assets/images/procedure/post.png" alt="" />
              </div>
              <div class="section3_radious_text">수신 제품 발송</div>
            </div>
          </div>
        </div>
        <div class="section4" style="padding-bottom:10px;">
          <div class="section_line">
            <div class="section_line_text" style="min-width:88px;">제품 보내실 곳</div>
            <div class="section_line_line"></div>
          </div>
          <div>
            <div class="section4_text_line">
              <div class="section4_imt">●</div>
              <div class="section4_text">경기도 포천시 송선로 268-64(선단동) 조이웍스 <br> 물류센터 A/S 담당자 앞</div>
            </div>
            <!-- <br> -->
            <div class="section4_text_line">
              <div class="section4_imt">●</div>
              <div class="section4_text"><span class="text_hilight">대표번호 : </span><a style="color:#006da1; " href="tel:031-524-9858">031-524-9858</a></div>
            </div>
          </div>
        </div>
        <div class="section4" style="padding-top:10px;">
          <div class="section_line">
            <div class="section_line_text">주의사항</div>
            <div class="section_line_line"></div>
          </div>
          <div>
            <div class="section4_text_title">다음 사항에 대해서는 AS가 불가능 합니다.</div>
            <div class="section4_text_line">
              <div class="section4_imt">●</div>
              <div class="section4_text"><span class="text_hilight">하이킹</span>(등산화)이 아닌 제품은 창갈이 <span class="text_hilight">AS 불가</span></div>
            </div>
            <div class="section4_text_line">
              <div class="section4_imt">●</div>
              <div class="section4_text"><span class="text_hilight">인솔</span>(내부 깔창) 및 <span class="text_hilight">슈레이스</span>(신발 끈) <span class="text_hilight">AS 불가</span></div>
            </div>
            <div class="section4_text_line">
              <div class="section4_imt">●</div>
              <div class="section4_text"><span class="text_hilight">잘 못된 세탁</span>에 의해 <span class="text_hilight">훼손</span>된 제품</div>
            </div>
            <div class="section4_text_line">
              <div class="section4_imt">●</div>
              <div class="section4_text">조이웍스 유통망이 아닌 <span class="text_hilight">병행수입</span> 된 제품</div>
            </div>
            <div class="section4_text_line">
              <div class="section4_imt">●</div>
              <div class="section4_text">택배 발송 시 <span class="text_hilight">인적사항 동봉</span></div>
            </div>
          </div>
          <!-- <div class="img_info_box">
            <el-image class="img_info_sample" :src="require(`@/assets/images/info_3.jpg`)" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[require(`@/assets/images/info_3.jpg`)]" fit="cover"></el-image>
          </div> -->
          <div class="section4_button_wrap" @click="checkIn" :class="{ check_in: !checkFlag }">
            <img class="check_img" v-if="checkFlag" src="../assets/images/procedure/check.png" alt="" />
            <img class="check_img" v-if="!checkFlag" src="../assets/images/procedure/check_out.svg" alt="" />
            <div class="button_text">확인 했습니다.</div>
          </div>
        </div>
        <div class="section5">
          <div class="section_line">
            <div class="section_line_text">AS 신청</div>
            <div class="section_line_line"></div>
          </div>
          <div class="section5_wrap">
            <div class="section5_text"><span class="section5_imt">*</span>는 필수항목 입니다.</div>
          </div>
          <div class="input_wrap">
            <div class="input_label">성명<span class="section5_imt">*</span></div>
            <div><input class="input_text" placeholder="성명" :readonly="readOnlyFlag" type="text" v-model="param.CUS_NAME" /></div>
          </div>
          <div class="input_wrap">
            <div class="input_label">전화번호<span class="section5_imt">*</span></div>
            <div class="input_number_wrap">
              <input class="input_number" type="text" v-model="phone.phone1" readonly />
              <input class="input_number" type="text" v-model="phone.phone2" readonly />
              <input class="input_number" type="text" v-model="phone.phone3" readonly />
            </div>
            <div class="input_desc">반드시 000-0000-0000 형태로 입력해 주세요.</div>
          </div>
          <div class="input_wrap">
            <div class="input_label">주소<span class="section5_imt">*</span></div>
            <div class="input_text_wrap">
              <input class="input_text" placeholder="주소" @click="searchAddr" type="text" v-model="param.CUS_ADDR" :readonly="readOnlyFlag" />
              <input class="input_text" placeholder="상세주소" type="text" v-model="param.CUS_ADDR2" :readonly="readOnlyFlag" />
            </div>
            <img class="icon_search" @click="searchAddr" src="../assets/images/procedure/search.png" alt="" />
          </div>
          <div class="input_wrap">
            <div class="input_label">제품명<span class="section5_imt">*</span></div>
            <div class="input_text_wrap">
              <input class="input_text" placeholder="제품명" type="text" v-model="param.ITM_NAME" :readonly="readOnlyFlag" />
            </div>
            <div class="input_desc">의뢰하신 제품 명을 기입해 주세요. (ex 본디8, 카하2 GTX등)</div>
          </div>
          <div class="input_wrap">
            <div class="input_label">색상<span class="section5_imt">*</span></div>
            <div class="input_text_wrap">
              <input class="input_text" placeholder="색상" type="text" v-model="param.COLOR_NAME" :readonly="readOnlyFlag" />
            </div>
            <div class="input_desc">색상(예) HOKA신발의 경우 :BBLC, DOTN 등 숫자 7 자리 옆에 표시<br />모를 경우 색상만 기입</div>
          </div>
          <div class="input_wrap">
            <div class="input_label">사이즈<span class="section5_imt">*</span></div>
            <div class="input_text_wrap">
              <input class="input_text" placeholder="사이즈" type="text" v-model="param.SIZE_NAME" :readonly="readOnlyFlag" />
            </div>
            <div class="input_desc">(예) 270:신발 / XL: 의류 및 침낭류</div>
          </div>
          <div class="input_wrap">
            <div class="input_label">구매년월<span class="section5_imt">*</span></div>
            <div class="input_text_wrap">
              <!-- <input class="input_text" type="number" maxlength="6" v-model="param.BUY_YM" placeholder="YYYYMM" :readonly="readOnlyFlag" /> -->
              <el-date-picker v-model="param.BUY_YM" style="width: 100%; height: 39px" type="month" locale="ko" placeholder="YYYY. MM" value-format="YYYYMM" format="YYYY. MM" :readonly="readOnlyFlag" />
            </div>
          </div>
          <div class="input_wrap">
            <div class="input_label">수선 요청사항<span class="section5_imt">*</span></div>
            <div class="input_text_wrap">
              <textarea class="textArea_text" type="text" v-model="param.REMARK01" :readonly="readOnlyFlag"></textarea>
            </div>
            <div class="input_desc">수선이 필요한 사항에 대해서 구체적으로 적어주시기 바랍니다.</div>
          </div>
          <div class="radio_wrap">
            <div class="input_label">구매처</div>
            <div class="radio_box">
              <input id="online" name="buyshop" checked class="radio_radio" value="0" type="radio" v-model="storeType" :disabled="readOnlyFlag" />
              <label for="online" class="radio_desc">네이버 조이웍스 스토어</label>
            </div>
            <div class="radio_box">
              <input id="offline" name="buyshop" value="1" class="radio_radio" type="radio" v-model="storeType" :disabled="readOnlyFlag" />
              <label for="offline" class="radio_desc">공식 취급점</label>
            </div>
            <div class="button_label label_desc">구매하신 곳의 정확한 상호명과 영수증을 함께 제출해 주세요.</div>
            <div class="button_label label_desc">※ 구매처가 드롭다운 목록에 없을 경우, 공식 취급점이 아니므로 접수 불가 및 반송될 수 있습니다.</div>
            <div class="button_label label_desc">※ 무신사, 크림(KREAM) 등 외부 플랫폼을 통한 구매건의 경우
해당 플랫폼의 정책에 따라 구매처를 통해 접수 및 처리가 진행됩니다.
반드시 해당 구매처 고객센터를 통해 문의 부탁드립니다.</div>
            
          </div>
          <div v-if="storeType == 1" class="input_wrap">
            <div class="input_label">공식 취급점<span class="section5_imt">*</span></div>
            <div class="input_text_wrap">
              <!-- <Select2 v-if="storeType == 0" disabled :options="strList" :settings="{ width: '100%', height: '34px' }"></Select2>  -->
              <Select2 v-model="param.STR_CODE" :options="strList" :settings="{ width: '100%', height: '34px' }"></Select2>
            </div>
          </div>
          <div class="button_wrap">
            <div class="button_label">구매증빙 예시(1장)</div>
            <div>
              <el-image class="img_sample" :src="require(`@/assets/images/receipt.png`)" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[require(`@/assets/images/receipt.png`)]" fit="cover"></el-image>
              <!-- <img class="img_sample" src="../assets/images/receipt.png" alt="" /> -->
            </div>
            <div class="radio_box">
              <input id="receipt" name="buy_gubun" checked class="radio_radio" value="1" type="radio" v-model="param.RECEIPT_GUBUN" :disabled="readOnlyFlag" />
              <label for="receipt" class="radio_desc">일반 영수증</label>
            </div>
            <div class="radio_box">
              <input id="vircle" name="buy_gubun" value="2" class="radio_radio" v-model="param.RECEIPT_GUBUN" type="radio" :disabled="readOnlyFlag" />
              <label for="vircle" class="radio_desc">버클(정품인증서)</label>
            </div>
            <div class="button_label label_desc">※구매증빙 미 첨부시 유상 접수 혹은 접수불가 판정을 받을 수 있습니다.</div>
            <div class="button_label label_desc">[단, 버클(정품인증서)을 발급받으신 고객님께서는 인증서 캡쳐 본을 첨부하시면 됩니다.]</div>
            <div v-if="fileList.file3.length != 0" style="display: flex; gap: 6px">
              <div class="img_box" v-for="cnt in fileList.file3" :key="cnt">
                <el-image style="height: 100%" :src="cnt.src" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[cnt.src]" fit="cover"></el-image>
                <img class="icon_cancel" src="../assets/images/procedure/cancel.png" alt="" @click="DelFile3Img(cnt)" />
              </div>
            </div>
            <div v-else class="button_text_wrap" @click="AddImg(file3)">
              <div class="button_text">이미지 첨부</div>
              <img class="icon_plus" src="../assets/images/procedure/plus.png" alt="" />
            </div>
            <input type="file" name="" ref="file3" accept=".jpg, .png, .jpeg" @change="updateImg3(file3)" style="display: none" />
            <div class="input_desc">구매한 영수증이나 인터넷 몰 구매내역 캡쳐 본</div>
          </div>
          <div class="button_wrap">
            <div class="button_label">제품 택 이미지 예시(최대 2장)</div>
            <div>
              <el-image class="img_sample" :src="require(`@/assets/images/tag.jpg`)" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[require(`@/assets/images/tag.jpg`)]" fit="cover"></el-image>
            </div>
            <div v-if="fileList.file1.length != 0" style="display: flex; gap: 6px; flex-wrap: wrap">
              <div class="img_box" v-for="cnt in fileList.file1" :key="cnt">
                <el-image style="height: 100%" :src="cnt.src" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[cnt.src]" fit="cover"></el-image>
                <img class="icon_cancel" src="../assets/images/procedure/cancel.png" alt="" @click="DelFile1Img(cnt)" />
              </div>
              <div class="img_box" style="cursor: pointer" v-if="fileList.file1.length < 2 && readOnlyFlag == false" @click="AddImg(file1)">
                <img class="icon_plus" src="../assets/images/procedure/plus.png" alt="" />
              </div>
            </div>
            <div v-else class="button_text_wrap" @click="AddImg(file1)">
              <div class="button_text">이미지 첨부</div>
              <img class="icon_plus" src="../assets/images/procedure/plus.png" v-if="readOnlyFlag == false" alt="" />
            </div>
            <input type="file" name="" ref="file1" accept=".jpg, .png, .jpeg" @change="updateImg1(file1)" style="display: none" multiple />
            <div class="input_desc">선명하게 촬영해 주세요</div>
          </div>
          <div class="button_wrap">
            <div class="button_label">수선이 필요한 부분 사진 예시(최대 3장)</div>
            <div>
              <el-image class="img_sample" :src="require(`@/assets/images/repair_needs.jpg`)" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[require(`@/assets/images/repair_needs.jpg`)]" fit="cover"></el-image>
            </div>
            <div v-if="fileList.file2.length != 0" style="display: flex; gap: 6px">
              <div class="img_box" v-for="cnt in fileList.file2" :key="cnt">
                <el-image style="height: 100%" :src="cnt.src" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[cnt.src]" fit="cover"></el-image>
                <img class="icon_cancel" src="../assets/images/procedure/cancel.png" alt="" @click="DelFile2Img(cnt)" />
              </div>
              <div class="img_box" style="cursor: pointer" v-if="fileList.file2.length < 3 && readOnlyFlag == false" @click="AddImg(file2)">
                <img class="icon_plus" src="../assets/images/procedure/plus.png" alt="" />
              </div>
            </div>
            <div v-else class="button_text_wrap" @click="AddImg(file2)">
              <div class="button_text">이미지 첨부</div>
              <img class="icon_plus" src="../assets/images/procedure/plus.png" alt="" />
            </div>
            <input type="file" name="" ref="file2" accept=".jpg, .png, .jpeg" @change="updateImg2(file2)" style="display: none" multiple />
            <div class="input_desc">필수 항목입니다.</div>
          </div>
          <div class="button_wrap">
            <div class="button_label">약관 동의<span class="section5_imt">(필수)</span></div>
            <div class="agree_button_wrap" @click="checkAgreement" :class="{ check_in: !checkAgree }">
              <img class="check_img" v-if="checkAgree" src="../assets/images/procedure/check.png" alt="" />
              <img class="check_img" v-if="!checkAgree" src="../assets/images/procedure/check_out.svg" alt="" />
              <div class="button_text">약관 전체 동의</div>
            </div>
          </div>
          <div class="agreement_wrap">
            <div class="agreement_box">
              <img class="check_img" src="../assets/images/procedure/check.png" @click="checkAgreement1()" alt="" v-if="checkAgree1 == true" />
              <img class="check_img" src="../assets/images/procedure/check_out.svg" @click="checkAgreement1()" alt="" v-if="checkAgree1 == false" />
              <div class="agreement_text" @click="checkAgreement1()">개인정보 제공 동의</div>
              <img class="arrow_img" src="../assets/images/procedure/icon_arrow-right.png" alt="" @click="termsFlag1 = true" />
            </div>
            <div class="agreement_box">
              <img class="check_img" src="../assets/images/procedure/check.png" alt="" @click="checkAgreement2()" v-if="checkAgree2 == true" />
              <img class="check_img" src="../assets/images/procedure/check_out.svg" alt="" @click="checkAgreement2()" v-if="checkAgree2 == false" />
              <div class="agreement_text" @click="checkAgreement2()">개인정보 처리 위탁 동의</div>
              <img class="arrow_img" src="../assets/images/procedure/icon_arrow-right.png" alt="" @click="termsFlag2 = true" />
            </div>
            <!-- <div class="agreement_box">
              <img class="check_img" src="../assets/images/procedure/check.png" alt="" />
              <div class="agreement_text">주요 안내 사항에 대한 동의</div>
              <img class="arrow_img" src="../assets/images/procedure/icon_arrow-right.png" alt="" />
            </div> -->
          </div>
          <div class="button_regist_wrap">
            <div class="button_regist" v-if="!readOnlyFlag && route.params.SEQ_NO != null" @click="save()">수정하기</div>
            <div class="button_regist" v-if="!route.params.SEQ_NO" @click="save()">접수하기</div>
          </div>
        </div>
        <div class="terms" v-if="termsFlag1">
          <Terms1View></Terms1View>
          <div class="terms_btn button_regist termsChk" @click="termsFlag1 = false">확인</div>
        </div>
        <div class="terms" v-if="termsFlag2">
          <Terms2View></Terms2View>
          <div class="terms_btn button_regist termsChk" @click="termsFlag2 = false">확인</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue";
import repairAPI from "@/api/repairAPI";
import codeAPI from "@/api/codeAPI";
import router from "@/router";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Terms1View from "@/views/Terms1View.vue";
import Terms2View from "./Terms2View.vue";
import authAPI from "@/api/authAPI";
const store = useStore();
const route = useRoute();
const userInfo = ref();
const readOnlyFlag = ref(false);
const storeType: any = ref(0);
const param: any = ref({
  STR_CODE: "",
  CUS_NAME: "",
  CUS_HP_NO: "",
  ITM_NAME: "",
  REMARK01: "",
  ZIP_CODE: "",
  CUS_ADDR: "",
  CUS_ADDR2: "",
  SIZE_NAME: "",
  COLOR_NAME: "",
  BUY_YM: "",
  RECEIPT_GUBUN: "",
});
const phone: any = ref({
  phone1: "",
  phone2: "",
  phone3: "",
});
const file1 = ref();
const file2 = ref();
const file3 = ref();
const fileList: any = ref({ file1: [], file2: [], file3: [] });
// const url = ref("http://localhost:8081/joyworks_as_api");
const url = ref("https://service.joy-works.co.kr/");



const checkFlag: any = ref(false);
const checkAgree: any = ref(false);
const checkAgree1: any = ref(false);
const checkAgree2: any = ref(false);
const strList: any = ref([]);
const termsFlag1: any = ref(false);
const termsFlag2: any = ref(false);
const checkSession = () => {
  authAPI
    .checkSession()
    .then((res: any) => {
      console.log(res);
      const data = res.data.data;
      if (data.result == "FAIL") {
        router.push({ name: "clientLogin" });
      }
    })
    .catch((error: any) => {
      console.log(error);
      alert(error);
    });
};
// const base64PreFix = (data: any) => {
//   return "data:image/png;base64," + data;
// };

onMounted(() => {
  checkSession();
  getStr();
  userInfo.value = store.getters.getUserInfo;
  phone.value.phone1 = userInfo.value.EMP_NO.substr(0, 3);
  phone.value.phone2 = userInfo.value.EMP_NO.substr(3, 4);
  phone.value.phone3 = userInfo.value.EMP_NO.substr(7, 4);
  if (route.params.SEQ_NO) {
    checkFlag.value = true;
    checkAgree.value = true;
    checkAgree1.value = true;
    checkAgree2.value = true;
    repairAPI.GetRepairDetail({ SEQ_NO: route.params.SEQ_NO, CUS_HP_NO: userInfo.value.EMP_NO }).then((res) => {
      param.value = res.data.data;
      // param.value.BUY_YM = convertDateYm(param.value.BUY_YM);
      phone.value.phone1 = param.value.CUS_HP_NO.substr(0, 3);
      phone.value.phone2 = param.value.CUS_HP_NO.substr(3, 4);
      phone.value.phone3 = param.value.CUS_HP_NO.substr(7, 4);
      if (route.params.SEQ_NO && param.value.CS_STATUS != null) {
        readOnlyFlag.value = true;
      }
      res.data.data.IMG_LIST.map((data: any) => {
        if (data.IMG_GUBUN == "01") {
          fileList.value.file1.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ, src: url.value + data.IMG_PATH });
        } else if (data.IMG_GUBUN == "02") {
          fileList.value.file2.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ, src: url.value + data.IMG_PATH });
        } else {
          fileList.value.file3.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ, src: url.value + data.IMG_PATH });
        }
      });
    });
  }
});

const AddImg = (el: any) => {
  if (readOnlyFlag.value == true) {
    return;
  }
  if (el == file1.value) {
    if (fileList.value.file1.length < 2) {
      file1.value.click();
    } else {
      alert("등록 가능한 이미지는 최대 2장입니다.");
    }
  } else if (el == file2.value) {
    if (fileList.value.file2.length < 4) {
      file2.value.click();
    } else {
      alert("등록 가능한 이미지는 최대 3장입니다.");
    }
  } else {
    file3.value.click();
  }
};
let removeImgList: any = [];
const DelFile1Img = (el: any) => {
  if (readOnlyFlag.value == true) {
    return;
  }
  fileList.value.file1.map((data: any, idx: any) => {
    if (data == el) {
      fileList.value.file1.splice(idx, 1);
      if (data.IMG_SEQ) {
        removeImgList.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ });
      }
    }
  });
};
const DelFile2Img = (el: any) => {
  if (readOnlyFlag.value == true) {
    return;
  }
  fileList.value.file2.map((data: any, idx: any) => {
    if (data == el) {
      fileList.value.file2.splice(idx, 1);
      if (data.IMG_SEQ) {
        removeImgList.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ });
      }
    }
  });
};
const DelFile3Img = (el: any) => {
  if (readOnlyFlag.value == true) {
    return;
  }
  fileList.value.file3.map((data: any, idx: any) => {
    if (data == el) {
      fileList.value.file3.splice(idx, 1);
      if (data.IMG_SEQ) {
        removeImgList.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ });
      }
    }
  });
};

const updateImg1 = (el: any) => {
  var fileArr = Array.prototype.slice.call(el.files);
  fileArr.map((file: any) => {
    if (file.type == "image/png" || file.type == "image/jpg" || file.type == "image/jpeg") {
      var reader = new FileReader();
      reader.onload = function (readerEvent: any) {
        file.src = reader.result;
        if (el.files.length + fileList.value.file1.length > 2) {
          alert("등록 가능한 이미지는 최대 2장입니다.");
          file1.value.value = "";
        } else {
          const image = new Image();
          image.onload = function () {
            let canvas: any = document.createElement("canvas");
            let max_size = 1280;
            // 최대 기준을 1280으로 잡음.
            let width = image.width;
            let height = image.height;
            if (width > height) {
              if (width > max_size) {
                height *= max_size / width;
                width = max_size;
              }
            } else {
              // 세로가 길 경우
              if (height > max_size) {
                width *= max_size / height;
                height = max_size;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            file = dataUrlToFile(canvas.toDataURL("image/jpeg"), file.name);
            file.src = canvas.toDataURL("image/jpeg");
            fileList.value.file1.push(file);
            file1.value.value = "";
          };
          image.src = readerEvent.target.result;
          // fileList.value.file1.push(file);
          // file1.value.value = "";
        }
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
      reader.readAsDataURL(file);
    } else {
      alert("이미지 파일이 아닙니다.");
      return;
    }
  });
};

const updateImg2 = (el: any) => {
  var fileArr = Array.prototype.slice.call(el.files);
  fileArr.map((file: any) => {
    if (file.type == "image/png" || file.type == "image/jpg" || file.type == "image/jpeg") {
      var reader = new FileReader();
      reader.onload = function (readerEvent: any) {
        file.src = reader.result;
        if (el.files.length + fileList.value.file2.length > 3) {
          alert("등록 가능한 이미지는 최대 3장입니다.");
          file2.value.value = "";
        } else {
          const image = new Image();
          image.onload = function () {
            let canvas: any = document.createElement("canvas");
            let max_size = 1280;
            // 최대 기준을 1280으로 잡음.
            let width = image.width;
            let height = image.height;
            if (width > height) {
              if (width > max_size) {
                height *= max_size / width;
                width = max_size;
              }
            } else {
              // 세로가 길 경우
              if (height > max_size) {
                width *= max_size / height;
                height = max_size;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            file = dataUrlToFile(canvas.toDataURL("image/jpeg"), file.name);

            file.src = canvas.toDataURL("image/jpeg");
            fileList.value.file2.push(file);
            file2.value.value = "";
          };
          image.src = readerEvent.target.result;
        }
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
      reader.readAsDataURL(file);
    } else {
      alert("이미지 파일이 아닙니다.");
      return;
    }
  });
};
const updateImg3 = (el: any) => {
  var fileArr = Array.prototype.slice.call(el.files);
  fileArr.map((file: any) => {
    if (file.type == "image/png" || file.type == "image/jpg" || file.type == "image/jpeg") {
      var reader = new FileReader();
      reader.onload = function (readerEvent: any) {
        const image = new Image();
        image.onload = function () {
          let canvas: any = document.createElement("canvas");
          let max_size = 1280;
          // 최대 기준을 1280으로 잡음.
          let width = image.width;
          let height = image.height;
          if (width > height) {
            if (width > max_size) {
              height *= max_size / width;
              width = max_size;
            }
          } else {
            // 세로가 길 경우
            if (height > max_size) {
              width *= max_size / height;
              height = max_size;
            }
          }
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(image, 0, 0, width, height);
          file = dataUrlToFile(canvas.toDataURL("image/jpeg"), file.name);

          file.src = canvas.toDataURL("image/jpeg");
          fileList.value.file3.push(file);
          file3.value.value = "";
        };
        image.src = readerEvent.target.result;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
      reader.readAsDataURL(file);
    } else {
      alert("이미지 파일이 아닙니다.");
      return;
    }
  });
};
const dataUrlToFile = (dataUrl: any, filename: any) => {
  var blobBin = atob(dataUrl.split(",")[1]); // base64 데이터 디코딩
  var array = [];
  for (var i = 0; i < blobBin.length; i++) {
    array.push(blobBin.charCodeAt(i));
  }
  return new File([new Uint8Array(array)], filename.split(".")[0] + ".jpeg", { type: "image/jpeg" }); // Blob 생성
};
const save = () => {
  if (checkFlag.value != true) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "주의사항을 확인하세요.",
    });
    return;
  }
  if (param.value.CUS_NAME == "" || param.value.CUS_NAME.length > 8) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "성명을 확인하세요.",
    });
    return;
  }
  if (param.value.CUS_ADDR == "") {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "주소를 확인하세요.",
    });
    return;
  }
  if (param.value.CUS_ADDR2 == "") {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "상세주소를 확인하세요.",
    });
    return;
  }
  if (param.value.ITM_NAME == "" || param.value.ITM_NAME.length > 30) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "제품명을 확인하세요.",
    });
    return;
  }
  if (param.value.COLOR_NAME == "" || param.value.COLOR_NAME.length > 10) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "색상을 확인하세요.",
    });
    return;
  }
  if (param.value.SIZE_NAME == "" || param.value.SIZE_NAME.length > 5) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "사이즈을 확인하세요.",
    });
    return;
  }
  if (param.value.BUY_YM == "") {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "구매년월을 확인하세요.",
    });
    return;
  }
  // if (param.value.REMARK01 == "") {
  //   window.customAlert({
  //     title: "A/S 고객접수",
  //     msg: "수선요청사항을 확인하세요.",
  //   });
  //   return;
  // }
  if (storeType.value == "1" && param.value.STR_CODE == "") {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "구매처를 확인하세요.",
    });
    return;
  }
  if (checkAgree.value != true) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "약관에 동의해주세요.",
    });
    return;
  }
  // storeType에 상관없이 본사로 지정
  param.value.STR_CODE = "0000";
  param.value.storeType;
  let formData = new FormData();
  param.value.CUS_HP_NO = phone.value.phone1 + "" + phone.value.phone2 + "" + phone.value.phone3;
  param.value.removeImgList = JSON.stringify(removeImgList);
  formData.append(
    "param",
    new Blob([JSON.stringify(param.value)], {
      type: "application/json",
    })
  );
  for (let i = 0; i < fileList.value.file1.length; i++) {
    if (!fileList.value.file1[i].IMG_SEQ) {
      formData.append("file1", fileList.value.file1[i]);
    }
  }
  for (let i = 0; i < fileList.value.file2.length; i++) {
    if (!fileList.value.file2[i].IMG_SEQ) {
      formData.append("file2", fileList.value.file2[i]);
    }
  }
  for (let i = 0; i < fileList.value.file3.length; i++) {
    if (!fileList.value.file3[i].IMG_SEQ) {
      formData.append("file3", fileList.value.file3[i]);
    }
  }
  window.customConfirm({
    title: "A/S 고객접수",
    msg: "접수하시겠습니까?",
    sCb: function () {
      repairAPI.SetCustomerRepair(formData).then((res: any) => {
        if (res.data.status == 200) {
          param.value.SEQ_NO = res.data.data.result;
          window.customAlert({
            title: "A/S 고객접수",
            msg: "AS 접수가 완료되었습니다",
            sCb: function () {
              router.push({ name: "clientDetail", params: { SEQ_NO: param.value.SEQ_NO } });
              removeImgList = [];
            },
          });
        }
      });
    },
  });
};
const searchAddr = () => {
  if (readOnlyFlag.value == true) {
    return;
  }

  new window.daum.Postcode({
    oncomplete: (data: any) => {
      param.value.CUS_ADDR = data.jibunAddress != "" ? data.jibunAddress : data.autoJibunAddress;
      param.value.ZIP_CODE = data.zonecode;
      // param.value.ZIP_CODE = data.jibunAddress != "" ? data.jibunAddress : data.autoJibunAddress;
    },
  }).open({
    popupName: "addressPop",
  });
};
const getStr = () => {
  codeAPI.getStr().then((res: any) => {
    const resData = res.data.data;
    resData.map((data: any) => {
      strList.value.push({ id: data.STR_CODE, text: data.STR_NAME });
    });
  });
};
const checkAgreement = () => {
  if (readOnlyFlag.value == true) {
    return;
  }
  checkAgree.value = !checkAgree.value;
  if (checkAgree.value) {
    checkAgree1.value = true;
    checkAgree2.value = true;
  } else {
    checkAgree1.value = false;
    checkAgree2.value = false;
  }
};
const checkAgreement1 = () => {
  if (readOnlyFlag.value == true) {
    return;
  }
  checkAgree1.value = !checkAgree1.value;
  if (checkAgree1.value && checkAgree2.value) {
    checkAgree.value = true;
  } else {
    checkAgree.value = false;
  }
};
const checkAgreement2 = () => {
  if (readOnlyFlag.value == true) {
    return;
  }
  checkAgree2.value = !checkAgree2.value;
  if (checkAgree1.value && checkAgree2.value) {
    checkAgree.value = true;
  } else {
    checkAgree.value = false;
  }
};
const checkIn = () => {
  if (readOnlyFlag.value == true) {
    return;
  }
  checkFlag.value = !checkFlag.value;
};
const goHome = () => {
  router.push({ name: "clientHome" });
};
const goBack = () => {
  router.go(-1);
};
</script>
<style scoped>
.section_header_wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 26px;
}
.section_header_wrap > img {
  height: 26px;
}
.section_header_wrap > div:nth-child(2) {
  height: 26px;
}
.back_btn_box {
  display: flex;
  align-items: center;
  float: left;
  cursor: pointer;
}
.section_header_wrap > img:last-child {
  margin-left: calc(50% - 110px);
  margin-right: auto;
}
.back_btn_box > div {
  color: #ffffff;
}
.img {
  height: 940px;
}
.img > img {
  width: 100%;
  height: 100%;
}
.title_text {
  font-size: 30px;
  color: white;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.title_text > div:nth-child(1) {
  font-family: "Noto Sans CJK KR-Light";
  line-height: 36px;
  font-weight: 300;
}
.title_text > div:nth-child(2) {
  font-weight: 900;
  line-height: 36px;
}

.form_container > .section1:nth-child(1) {
  background: #006da1;
  background-image: url(../assets/images/HOKA_logo2.png);
  background-repeat: no-repeat;
  background-position-x: right;
  background-position-y: bottom;
  height: 186px;
  padding: 17px 15px 30px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.title_img {
  display: flex;
  justify-content: flex-start;
}
.opacity_wrapper {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  position: fixed;
  top: 0px;
  left: 0px;
}
.form_container {
  background: white;
  position: fixed;
  top: calc(0%);
  right: calc(10%);
  width: 382px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.section2 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 19px 32px 22px 32px;
}
.section2_text {
  font-family: "Noto Sans CJK KR-Regular";
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  color: #5b5b5b;
  letter-spacing: -0.2px;
}
.section3 {
  padding: 0px 30px;
}
.section3 .section_line_text {
  min-width: 105px;
}
.section4 .section_line_text {
  min-width: 51px;
}
.section5 .section_line_text {
  min-width: 47px;
}
.section3_radious {
  width: 83px;
  height: 83px;
  border: 2px solid #006da1;
  border-radius: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.section3_icon_wrap {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  gap: 5px;
  align-items: center;
}
.section3_radious_text {
  font-size: 10px;
  width: 50px;
  text-align: center;
  letter-spacing: -0.2px;
  color: #262626;
  font-family: "Noto Sans CJK KR-Bold";
  line-height: 11px;
}
.radious_number {
  position: absolute;
  border: 1px solid #006da1;
  border-radius: 50px;
  width: 26px;
  height: 26px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: #006da1;
  left: 0;
  top: 0;
}
.section_line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.section_line_text {
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #006da1;
  margin-bottom: 37px;
  letter-spacing: -0.2px;
}
.section_line_line {
  border-top: 1px solid #006da1;
  width: 200px;
  height: 0px;
  margin-bottom: 37px;
}

.section4 {
  padding: 46px 30px 30px 30px;
}
.section4 > .section_line > .section_line_line {
  width: 252px;
  margin-bottom: 10px;
}
.section4 > .section_line > .section_line_text {
  margin-bottom: 10px;
}
.section4_text_line {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  line-height: 18px;
}
.section4_imt {
  color: #006da1;
  font-size: 8px;
}
.section4_text {
  font-size: 12px;
  color: #006da1;
}
.text_hilight {
  font-family: "Noto Sans CJK KR-Bold";
}
.section4_text_title {
  font-size: 10px;
  color: #5b5b5b;
  line-height: 14px;
  letter-spacing: -0.2px;
  margin-bottom: 10px;
}
.section4_button_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 37px;
  border: 2px solid #006da1;
  border-radius: 8px;
  gap: 10px;
  margin-top: 16px;
  cursor: pointer;
}

.section5 {
  padding: 30px 30px 40px 30px;
  background-color: #f3f5fb;
}
.section5 > .section_line > .section_line_line {
  width: 252px;
}
.section5_imt {
  color: #006da1;
}
.section5_wrap {
  margin-bottom: 15px;
}
.section5_text {
  font-size: 12px;
  font-family: "Noto Sans CJK KR-Medium";
}
.input_wrap {
  display: flex;
  gap: 5px;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
}
.input_label {
  font-size: 12px;
  font-family: "Noto Sans CJK KR-Medium";
}
.input_text {
  border: 2px solid #ffffff;
  border-radius: 6px;
  width: 100%;
  height: 39px;
  padding: 8px 8px 8px 8px;
  font-size: 14px;
  line-height: 22px;
  font-family: "Noto Sans CJK KR-Regular";
  color: #000000;
}
.input_number_wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
}
.input_number {
  width: 100%;
  border: 2px solid #ffffff;
  border-radius: 6px;
  height: 39px;
  padding: 8px 8px 8px 8px;
  font-size: 14px;
  line-height: 22px;
  font-family: "Noto Sans CJK KR-Regular";
  color: #000000;
}
.input_desc {
  font-size: 10px;
  font-family: "Noto Sans CJK KR-Light";
  line-height: 14px;
  letter-spacing: -0.2px;
  color: #5b5b5b;
}
.input_text_wrap {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.input_text_wrap > .select2 {
  font-size: 14px;
}
.icon_search {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 34px;
  right: 10px;
  cursor: pointer;
}
.textArea_text {
  border: 2px solid #ffffff;
  border-radius: 6px;
  width: 100%;
  height: 156px;
  padding: 8px 8px 8px 8px;
  font-size: 14px;
  line-height: 22px;
  font-family: "Noto Sans CJK KR-Regular";
  color: #000000;
  resize: none;
}
.radio_wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}
.radio_wrap > .radio_box:nth-child(1) {
  margin-bottom: 9px;
}
.radio_box {
  display: flex;
  align-items: center;
  gap: 8px;
}
.radio_desc {
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.2px;
  font-family: "Noto Sans CJK KR-Regular";
  cursor: pointer;
}
.radio_radio {
  width: 20px;
  height: 20px;
  margin: 0px;
  cursor: pointer;
}
.icon_search2 {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 34px;
  left: 288px;
  cursor: pointer;
}
.button_wrap {
  display: flex;
  gap: 5px;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 20px;
}
.button_label {
  font-size: 12px;
  font-family: "Noto Sans CJK KR-Medium";
}
.button_text {
  font-size: 14px;
  color: #006da1;
  line-height: 20px;
  letter-spacing: -0.2px;
}
.button_text_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 37px;
  background-color: #ffffff;
  border-radius: 8px;
  gap: 10px;
  cursor: pointer;
}

.button_desc {
  font-size: 12px;
}
.icon_plus {
  width: 12px;
  height: 12px;
}
.icon_cancel {
  position: absolute;
  right: 6px;
  top: 6px;
}
.agree_button_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 37px;
  border: 2px solid #006da1;
  background-color: #ffffff;
  border-radius: 8px;
  gap: 10px;
  cursor: pointer;
}
.agreement_box {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 0px;
  border-bottom: 1px solid #efefef;
}
.agreement_wrap > .agreement_box:nth-child(1) {
  padding-top: 0px;
}
.agreement_wrap > .agreement_box:last-child {
  border-bottom: none;
  margin-bottom: 40px;
}

.agreement_text {
  font-size: 15px;
  line-height: 20px;
  cursor: pointer;
}
.arrow_img {
  margin-left: auto;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.button_regist {
  width: 100%;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #ffffff;
  line-height: 22px;
  text-align: center;
  background-color: #006da1;
  border-radius: 6px;
  min-height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.img_box {
  height: 100px;
  width: calc(33% - 6px);
  background-color: white;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.check_img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.check_in {
  border: 2px solid #c0c0c0;
  color: #c0c0c0;
}
.check_in > .button_text {
  color: #c0c0c0;
}

.terms {
  background-color: #f3f5fb;
  position: fixed;
  top: calc(0%);
  right: calc(5%);
  width: 382px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.termsChk {
  margin-top: 20px;
}
.img_sample {
  width: 100px;
  border-radius: 6px;
}
.img_info_sample {
  border: 2px solid #c0c0c0;
  border-radius: 6px;
}
.img_info_box {
  display: flex;
  justify-content: center;
  align-self: center;
  margin-top: 10px;
}
.label_desc {
  font-family: "Noto Sans CJK KR-Bold";
  color: red;
  font-size: 10px;
}
</style>
